import { computed, Injectable, signal } from '@angular/core';

/**
 * Global loading overlay. The overlay is mounted once in app.html, so show()/hide() work from any
 * page, modal or service. Calls are reference counted, so overlapping requests behave correctly.
 */
@Injectable({ providedIn: 'root' })
export class LoaderService {
  private readonly pending = signal(0);
  private readonly text = signal('Loading...');

  readonly visible = computed(() => this.pending() > 0);
  readonly message = this.text.asReadonly();

  show(message = 'Loading...'): void {
    this.text.set(message);
    this.pending.update((n) => n + 1);
  }

  hide(): void {
    this.pending.update((n) => Math.max(0, n - 1));
  }

  reset(): void {
    this.pending.set(0);
  }
}
